export const createConfigurationService = (configurationRepository) => {
    const getPlacerBookies = () => configurationRepository.getPlacerBookies();
    const updatePlacerBookies = (data) => configurationRepository.updatePlacerBookies(data);
    const updatePlacerBookie = (bookie, data) => configurationRepository.updatePlacerBookie(bookie, data);
    const getAnalyzedEvents = () => configurationRepository.getAnalyzedEvents();
    const addAnalyzedEvent = (eventId) => configurationRepository.addAnalyzedEvent(eventId);
    const removeAnalyzedEvent = (eventId) => configurationRepository.removeAnalyzedEvent(eventId);
    const getClaimableBetIds = () => configurationRepository.getClaimableBetIds();
    const addClaimableBetId = (betId) => configurationRepository.addClaimableBetId(betId);
    const removeClaimableBetId = (betId) => configurationRepository.removeClaimableBetId(betId);
    const getProxies = () => configurationRepository.getProxies();

    return {
        getPlacerBookies,
        updatePlacerBookies,
        updatePlacerBookie,
        getAnalyzedEvents,
        addAnalyzedEvent,
        removeAnalyzedEvent,
        getClaimableBetIds,
        addClaimableBetId,
        removeClaimableBetId,
        getProxies
    };
}; 